import { differenceInDays, format } from "date-fns";
import nl from "date-fns/esm/locale/nl/index.js";
import React, { Component } from "react";
import BulletboardResponseForm from "./BulletboardResponseForm";
import Label from "./Label";

export default class BulletboardItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            successMessage: null,
            errorMessage: null,
            showContent: false,
            showResponseForm: false
        };

        this.showContentToggle = this.showContentToggle.bind(this);

        this.contentToggle = React.createRef();

        const node = this.myRef;
        console.log(node);
    }

    renderItemTypeLabel() {
        const type = this.props.item.acf.bulletboard_item_type;
        const name = type === "offer" ? "Aangeboden" : "Gevraagd";
        const color = type === "offer" ? "green" : "orange";

        return <Label title={name} color={color} />;
    }

    renderItemIsNewLabel() {
        const date = new Date(this.props.item.date);
        const now = new Date();

        if (differenceInDays(now, date) <= 7) {
            return <Label title="Nieuw" color="purple" />;
        } else {
            return null;
        }
    }

    renderContent() {
        if (this.props.item.content.rendered.length < 300) {
            return (
                <div
                    className="card__description"
                    dangerouslySetInnerHTML={{
                        __html: this.props.item.content.rendered
                    }}
                ></div>
            );
        }
        return this.state.showContent ? (
            <div
                className="card__description"
                dangerouslySetInnerHTML={{
                    __html: this.props.item.content.rendered
                }}
            ></div>
        ) : (
            <div className="card__description">
                <span
                    ref={this.contentToggle}
                    dangerouslySetInnerHTML={{
                        __html: this.filterHTML(
                            this.props.item.excerpt.rendered
                        )
                    }}
                ></span>
                ...
                <button
                    className="card__description__link"
                    onClick={this.showContentToggle}
                >
                    Lees meer
                    <span className="sr-only">
                        over {this.props.item.title.rendered}
                    </span>
                </button>
            </div>
        );
    }

    showContentToggle() {
        this.setState({ showContent: !this.state.showContent });
    }

    renderDate() {
        return format(new Date(this.props.item.date), "d MMMM yyyy", {
            locale: nl
        });
    }

    toggleResponseForm(show) {
        this.setState({ showResponseForm: show });
    }

    renderCities() {
        if (
            !this.props.item.acf.bulletboard_item_city ||
            this.props.item.acf.bulletboard_item_city === null
        ) {
            return null;
        }

        return this.props.item.acf.bulletboard_item_city.map((city, index) => {
            return index >= 1 ? ", " + city.name : city.name;
        });
    }

    submitResponseForm(values) {
        return new Promise((resolve, reject) => {
            const headers = new Headers();
            headers.append("Content-Type", "application/json");

            values["nonce"] = this.props.addNewResponseNonce;

            this.setState({
                successMessage: null,
                errorMessage: null
            });

            const JSON_API_URL = `/wp-json/bulletboard/v1/response`;

            fetch(JSON_API_URL, {
                method: "post",
                headers,
                body: JSON.stringify(values)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.success) {
                        this.setState({ successMessage: data.status });

                        setTimeout(() => {
                            this.setState({ successMessage: null });
                            this.toggleResponseForm(false);
                        }, 10000);
                    } else {
                        this.setState({ errorMessage: data.status });
                    }

                    resolve();
                })
                .catch(errors => {
                    this.setState({ errorMessage: errors });
                    reject(errors);
                });
        });
    }

    filterHTML(html) {
        return html.replace(/<\/?[^>]+(>|$)/g, "");
    }

    render() {
        return (
            <li className="card__item">
                <article
                    key={this.props.item.id}
                    className="card card--bulletboard-item"
                >
                    <div className="card__pre-header">
                        {this.renderItemTypeLabel()}
                    </div>
                    <header className="card__header">
                        <h2 className="card__title">
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: this.props.item.title.rendered
                                }}
                            ></span>
                            {this.renderItemIsNewLabel()}
                        </h2>
                    </header>
                    <div className="card__meta">
                        {this.renderDate()}
                        {" - "}
                        {this.renderCities()}
                    </div>

                    {this.renderContent()}

                    <div className="card__footer">
                        {!this.state.showResponseForm ? (
                            <div className="buttons">
                                <button
                                    className="button button--primary button--small"
                                    onClick={e => this.toggleResponseForm(true)}
                                >
                                    Reageer op deze advertentie
                                    <span className="screen-reader-text">
                                        {`over ${this.props.item.title.rendered}`}
                                    </span>
                                </button>
                            </div>
                        ) : (
                            <BulletboardResponseForm
                                vogMessage={this.props.vogMessage}
                                recaptchaKey={this.props.recaptchaKey}
                                item={this.props.item}
                                successMessage={this.state.successMessage}
                                errorMessage={this.state.errorMessage}
                                onSubmit={values =>
                                    this.submitResponseForm(values)
                                }
                                onCancel={() => this.toggleResponseForm(false)}
                            />
                        )}
                    </div>
                </article>
            </li>
        );
    }
}
